<template>
  <m-maintenance-notification
    v-if="window.maintenance && window.maintenance.enabled"
    :maintenance="window.maintenance"
  />
  <router-view v-slot="{ Component }">
    <transition name="fade" mode="out-in">
      <component :is="Component" />
    </transition>
  </router-view>
</template>

<script lang="ts">
  import { defineComponent } from 'vue';
  import MMaintenanceNotification from '@shared/components/MMaintenanceNotification.vue';
  export default defineComponent({
    components: {
      MMaintenanceNotification,
    },
    setup() {
      return {
        window,
      };
    },
  });
</script>
